import React from 'react';
import PropTypes from 'prop-types';
import DropdownVariants from './DropdownVariants';
import SwatchVariants from './SwatchVariants';
import RadioVariants from './RadioVariants';


const VariationSelector = function VariationSelectorComponent({
  variationAttributes,
  showVariationHandler,
  handleDropownChange,
  pendingRequest,
}) {
  if (!variationAttributes) {
    return null;
  }
  return (
    <div className="product-details__variations">
      {variationAttributes.map((variationGroup) => {
        if (variationGroup.swatchable) {
          return (
            <SwatchVariants
              key={variationGroup.id}
              variationGroup={variationGroup}
              showVariationHandler={showVariationHandler}
              pendingRequest={pendingRequest}
            />
          );
        }
        if (variationGroup.values && variationGroup.values.length > 2) {
          return (
            <DropdownVariants
              key={variationGroup.id}
              variationGroup={variationGroup}
              handleDropownChange={handleDropownChange}
            />
          );
        }
        return (
          <RadioVariants
            key={variationGroup.id}
            variationGroup={variationGroup}
            showVariationHandler={showVariationHandler}
          />
        );
      })}
    </div>
  );
};

VariationSelector.propTypes = {
  variationAttributes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  showVariationHandler: PropTypes.func.isRequired,
  handleDropownChange: PropTypes.func.isRequired,
  pendingRequest: PropTypes.bool.isRequired,
};

export default VariationSelector;
